import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { Tooltip } from 'antd';

const Step01Theme = ({ theme, setTheme, itemType, globalCategory, t }) => {
  useEffect(() => {
    if (!theme) {
      setTheme(stepOne?.[globalCategory].title[0]);
    }
  }, []);

  const stepOne =
    itemType === 'expenses'
      ? {
          daily_life: {
            title: [
              'HOUSING',
              'FOOD_GROCERIES',
              'TRANSPORTATION',
              'HEALTH_WELLNESS',
              'CLOTHING_PERSONAL_CARE',
              'DIGITAL',
              'EVERYDAY_ACTIVITIES',
              'CASUAL_EATING_OUT',
            ],
            description: [
              'HOUSING_DESCRIPTION',
              '',
              'TRANSPORTATION_DESCRIPTION',
              'HEALTH_WELLNESS_DESCRIPTION',
              '',
              'DIGITAL_DESCRIPTION',
              'EVERYDAY_ACTIVITIES_DESCRIPTION',
              'CASUAL_EATING_OUT_DESCRIPTION',
            ],
          },
          lifestyle_experiences: {
            title: [
              'TRAVEL_VACATIONS',
              'SECOND_HOME_OR_WEEKEND_CABIN',
              'PERSONAL_OR_CREATIVE_PROJECTS',
              'PASSION_INVESTMENTS',
              'HOBBIES',
              'LIFESTYLE_UPGRADES',
              'SPECIAL_DIETING_EVENTS',
            ],
            description: [
              '',
              '',
              '',
              'PASSION_INVESTMENTS_DESCRIPTION',
              'HOBBIES_DESCRIPTION',
              'LIFESTYLE_UPGRADES_DESCRIPTION',
              'SPECIAL_DIETING_EVENTS_DESCRIPTION',
            ],
          },
          giving_legacy: {
            title: [
              'GIFTS_TO_CHILDREN',
              'SUPPORT_FOR_FAMILY_AND_FRIENDS',
              'CHARITABLE_DONATIONS',
              'INHERITANCE_PLANNING',
              'FAMILY_TRUST_OR_FUTURE_FUNDS',
              'GIVE_WHILE_LIVING_GOALS',
            ],
            description: ['GIFTS_TO_CHILDREN_DESCRIPTION', '', '', '', '', ''],
          },
        }
      : {
          salary: {
            title: ['BASE_SALARY', 'BONUS_COMMISSION', 'EMPLOYER_BENEFITS'],
            description: [],
          },
          capital_gain: {
            title: [
              'DIVIDENDS_AND_INTEREST',
              'REALIZED_GAINS',
              'RENTAL_INCOME',
            ],
            description: [],
          },
          other: {
            title: [
              'FREELANCE_SIDE_INCOME',
              'PENSION_TRANSFERS',
              'GIFTS_ONE_OFF_INCOME',
            ],
            description: [],
          },
        };

  return (
    <div className="stageitem-point">
      <h1 className="item-point-title">{t('STEP_ONE_PROMO')}</h1>
      {stepOne?.[globalCategory]?.title.map((i, index) => {
        return (
          <Tooltip
            key={index}
            title={t(stepOne?.[globalCategory]?.description[index])}
            placement="rightTop"
          >
            <div
              className={`item-point ${theme === i ? 'selected' : ''}`}
              onClick={() => setTheme(i)}
            >
              {t(i)}
            </div>
          </Tooltip>
        );
      })}
      <div className="stageitem-point-footer"></div>
    </div>
  );
};

export default Step01Theme;

Step01Theme.propTypes = {
  theme: PropTypes.string,
  setTheme: PropTypes.func,
  itemType: PropTypes.string,
  globalCategory: PropTypes.string,
  t: PropTypes.func,
};
